import { SalesOrderProduct } from '../containers/sales/types';
import { OrderDetails } from '../types';
import {api} from './api';

export const salesOrdersApi = api.injectEndpoints({
	endpoints: (builder) => ({
		salesOrderListPublic: builder.mutation({
			query: () => ({
				url: 'salesOrders/list',
				method: 'GET',
			}),
		}),
		salesOrderDetailsLoad: builder.mutation({
			query: (orderId: string) => ({
				url: `salesOrders/${orderId}`,
				method: 'GET',
			}),
		}),
		salesOrderGetInfo: builder.query<OrderDetails, string>({
			query: (orderId: string) => ({
				url: `salesOrders/${orderId}`, // TODO: rename endpoint to /getInfo to match the orders api
				method: 'GET',
			}),
		}),
		salesOrderAddExistingProduct: builder.mutation({
			query: (data: Partial<SalesOrderProduct>) => ({
				url: 'salesOrderProducts/addExistingProduct',
				body: data,
				method: 'POST',
			}),
		}),
		salesOrderAddNewProduct: builder.mutation({
			query: (data: Partial<SalesOrderProduct>) => ({
				url: 'salesOrderProducts/addNewProduct',
				body: data,
				method: 'POST',
			}),
		}),
		salesOrderProductDelete: builder.mutation({
			query: (orderProductId: number) => ({
				url: `salesOrderProducts/${orderProductId}`,
				method: 'DELETE',
			}),
		}),
		salesOrderSubmitOffer: builder.mutation({
			query: (props: { orderId: string, data: object }) => ({
				url: `salesOrders/${props.orderId}/submitOffer`,
				body: props.data,
				method: 'POST',
			}),
		}),
		salesOrderCancelOffer: builder.mutation({
			query: (props: { orderId: string, data: object }) => ({
				url: `salesOrders/${props.orderId}/cancelOffer`,
				body: props.data,
				method: 'POST',
			}),
		}),
		salesOrderRejectOrder: builder.mutation({
			query: (props: { orderId: string, data: object }) => ({
				url: `salesOrders/${props.orderId}/reject`,
				body: props.data,
				method: 'POST',
			}),
		}),
		salesOrderSetStatusShipped: builder.mutation({
			query: (props: { orderId: string }) => ({
				url: `salesOrders/${props.orderId}/setStatusShipped`,
				method: 'PUT',
			}),
		}),
		salesOrderSetStatusNotShipped: builder.mutation({
			query: (props: { orderId: string }) => ({
				url: `salesOrders/${props.orderId}/setStatusNotShipped`,
				method: 'PUT',
			}),
		}),
		salesOrderResendOrderConfirmationEmail: builder.mutation({
			query: (props: { orderId: string }) => ({
				url: `salesOrders/${props.orderId}/resendOrderConfirmationEmail`,
				method: 'POST',
			}),
		}),
	}),
});

export const {
	useSalesOrderAddExistingProductMutation,
	useSalesOrderAddNewProductMutation,
	useSalesOrderListPublicMutation,
	useSalesOrderDetailsLoadMutation,
	useSalesOrderProductDeleteMutation,
	useSalesOrderSubmitOfferMutation,
	useSalesOrderCancelOfferMutation,
	useSalesOrderRejectOrderMutation,
	useSalesOrderSetStatusShippedMutation,
	useSalesOrderSetStatusNotShippedMutation,
	useSalesOrderGetInfoQuery,
	useSalesOrderResendOrderConfirmationEmailMutation,
} = salesOrdersApi;
